import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Pagination, Row, Table, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from "react-i18next";
const StatusCell = ({ claim, getStatusBadge }) => {
  const { t } = useTranslation();

  return (
    <td>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {getStatusBadge(claim?.status)}
        {claim?.reinforcementAsk && (
          <Form.Check
            type="checkbox"
            checked={claim?.enforcementAllow || false} // checked if enforcementAllow is true
            readOnly // so user cannot change it here
          />
        )}
      </div>

    </td>
  );
};


export default StatusCell;
